export enum SellerParameterNamesEnum {
  REPORT_ID_TO_DOWNLOAD_PDF_ORDER = 'report_pdf_pedido',
}
